export default {
  // Equipment
  equipment: {
    title: 'อุปกรณ์',
    description: 'ติดตามและจัดการอุปกรณ์ทั้งหมดในสถานที่',
    new: 'เพิ่มอุปกรณ์',
    edit: 'แก้ไขอุปกรณ์',
    detail: 'รายละเอียดอุปกรณ์',
    warranty_alerts: 'แจ้งเตือนการรับประกัน',
  },

  // Work Orders
  work_orders: {
    title: 'ใบสั่งงาน',
    description: 'จัดการใบสั่งงานบำรุงรักษาและซ่อมแซม',
    new: 'ใบสั่งงานใหม่',
    edit: 'แก้ไขใบสั่งงาน',
    detail: 'รายละเอียดใบสั่งงาน',
  },

  // Vendors
  vendors: {
    title: 'ผู้ให้บริการ',
    description: 'จัดการผู้ให้บริการและผู้รับเหมา',
    new: 'เพิ่มผู้ให้บริการ',
    edit: 'แก้ไขผู้ให้บริการ',
    detail: 'รายละเอียดผู้ให้บริการ',
  },

  // Maintenance Schedules
  maintenance_schedules: {
    title: 'ตารางบำรุงรักษา',
    add: 'เพิ่มตาราง',
    edit: 'แก้ไขตาราง',
    no_schedules: 'ไม่มีตารางบำรุงรักษา',
  },

  // Work Order Parts
  parts: {
    title: 'อะไหล่',
    add: 'เพิ่มอะไหล่',
    edit: 'แก้ไขอะไหล่',
    no_parts: 'ยังไม่มีอะไหล่',
    total_cost: 'ต้นทุนอะไหล่รวม',
  },

  // Labels
  labels: {
    name: 'ชื่อ',
    category: 'หมวดหมู่',
    status: 'สถานะ',
    location: 'สถานที่',
    manufacturer: 'ผู้ผลิต',
    model_number: 'รุ่น',
    serial_number: 'หมายเลขซีเรียล',
    installed_at: 'วันที่ติดตั้ง',
    warranty_expires_at: 'วันหมดประกัน',
    notes: 'หมายเหตุ',
    images: 'รูปภาพ',
    property: 'อสังหาริมทรัพย์',
    title: 'หัวข้อ',
    description: 'รายละเอียด',
    priority: 'ความสำคัญ',
    equipment: 'อุปกรณ์',
    vendor: 'ผู้ให้บริการ',
    assigned_to: 'มอบหมายให้',
    maintenance_request: 'คำขอซ่อมบำรุง',
    lease: 'สัญญาเช่า',
    due_date: 'กำหนดส่ง',
    completed_at: 'วันที่เสร็จ',
    completed_by: 'เสร็จโดย',
    estimated_cost: 'ค่าใช้จ่ายประมาณ',
    actual_cost: 'ค่าใช้จ่ายจริง',
    quality_rating: 'คะแนนคุณภาพ',
    contact_name: 'ชื่อผู้ติดต่อ',
    phone: 'เบอร์โทร',
    email: 'อีเมล',
    address: 'ที่อยู่',
    specialties: 'ความเชี่ยวชาญ',
    active: 'ใช้งาน',
    avg_score: 'คะแนนเฉลี่ย',
    frequency: 'ความถี่',
    next_due_at: 'ครั้งถัดไป',
    last_completed_at: 'ครั้งล่าสุด',
    quantity: 'จำนวน',
    unit_cost: 'ราคาต่อหน่วย',
    total_cost: 'ราคารวม',
    created_at: 'สร้างเมื่อ',
    recent_work_orders: 'ใบสั่งงานล่าสุด',
  },

  // Categories
  categories: {
    hvac: 'ระบบปรับอากาศ',
    plumbing: 'ประปา',
    electrical: 'ไฟฟ้า',
    elevator: 'ลิฟต์',
    fire_safety: 'ระบบดับเพลิง',
    security: 'ความปลอดภัย',
    general: 'ทั่วไป',
  },

  // Equipment Status
  equipment_status: {
    operational: 'ใช้งานได้',
    needs_repair: 'ต้องซ่อม',
    out_of_service: 'หยุดให้บริการ',
    decommissioned: 'ปลดประจำการ',
  },

  // Work Order Status
  work_order_status: {
    open: 'เปิด',
    in_progress: 'กำลังดำเนินการ',
    completed: 'เสร็จสิ้น',
    cancelled: 'ยกเลิก',
    all: 'ทั้งหมด',
  },

  // Priorities
  priorities: {
    low: 'ต่ำ',
    medium: 'กลาง',
    high: 'สูง',
    urgent: 'เร่งด่วน',
    all: 'ทั้งหมด',
  },

  // Frequencies
  frequencies: {
    daily: 'รายวัน',
    weekly: 'รายสัปดาห์',
    biweekly: 'ทุก 2 สัปดาห์',
    monthly: 'รายเดือน',
    quarterly: 'รายไตรมาส',
    semi_annual: 'ทุก 6 เดือน',
    annual: 'รายปี',
  },

  // Actions
  actions: {
    start_work: 'เริ่มงาน',
    complete: 'เสร็จสิ้น',
    cancel_order: 'ยกเลิก',
    add_equipment: 'เพิ่มอุปกรณ์',
    add_work_order: 'เพิ่มใบสั่งงาน',
    add_vendor: 'เพิ่มผู้ให้บริการ',
    back_to_list: 'กลับรายการ',
    save: 'บันทึก',
  },

  // Forms
  form: {
    title_new_equipment: 'เพิ่มอุปกรณ์ใหม่',
    title_edit_equipment: 'แก้ไขอุปกรณ์',
    description_new_equipment: 'เพิ่มอุปกรณ์ใหม่เพื่อติดตาม',
    description_edit_equipment: 'อัปเดตข้อมูลอุปกรณ์',
    title_new_work_order: 'ใบสั่งงานใหม่',
    title_edit_work_order: 'แก้ไขใบสั่งงาน',
    description_new_work_order: 'สร้างใบสั่งงานใหม่',
    description_edit_work_order: 'อัปเดตรายละเอียดใบสั่งงาน',
    title_new_vendor: 'เพิ่มผู้ให้บริการใหม่',
    title_edit_vendor: 'แก้ไขผู้ให้บริการ',
    description_new_vendor: 'เพิ่มผู้ให้บริการหรือผู้รับเหมาใหม่',
    description_edit_vendor: 'อัปเดตข้อมูลผู้ให้บริการ',
    select_property: 'เลือกอสังหาริมทรัพย์',
    select_equipment: 'เลือกอุปกรณ์',
    select_vendor: 'เลือกผู้ให้บริการ',
    select_assigned_to: 'เลือกผู้รับมอบหมาย',
    select_category: 'เลือกหมวดหมู่',
    select_status: 'เลือกสถานะ',
    select_priority: 'เลือกความสำคัญ',
    select_frequency: 'เลือกความถี่',
    no_vendor: 'ไม่มีผู้ให้บริการ',
    no_equipment: 'ไม่มีอุปกรณ์',
    no_assignee: 'ไม่มีผู้รับมอบหมาย',
    no_maintenance_request: 'ไม่มีคำขอซ่อมบำรุง',
    no_lease: 'ไม่มีสัญญาเช่า',
    lease_locked_caption: 'เชื่อมโยงจากการเคลียร์เงินประกันสัญญาเช่า จึงล็อกสัญญาเช่านี้ไว้',
    equipment_or_lease_hint: 'ต้องเลือกอุปกรณ์หรือสัญญาเช่าอย่างน้อยหนึ่งอย่าง',
    specialties_placeholder: 'เช่น ระบบปรับอากาศ, ประปา (คั่นด้วยจุลภาค)',
    quality_rating_label: 'คะแนนคุณภาพ (1-5)',
  },

  // Messages
  messages: {
    delete_equipment_title: 'ลบอุปกรณ์',
    delete_equipment_confirm: 'คุณต้องการลบ "{{name}}" ใช่หรือไม่?',
    delete_work_order_title: 'ลบใบสั่งงาน',
    delete_work_order_confirm: 'คุณต้องการลบ "{{title}}" ใช่หรือไม่?',
    delete_vendor_title: 'ลบผู้ให้บริการ',
    delete_vendor_confirm: 'คุณต้องการลบ "{{name}}" ใช่หรือไม่?',
    delete_part_title: 'ลบอะไหล่',
    delete_part_confirm: 'คุณต้องการลบอะไหล่นี้ใช่หรือไม่?',
    delete_schedule_title: 'ลบตารางบำรุงรักษา',
    delete_schedule_confirm: 'คุณต้องการลบตารางนี้ใช่หรือไม่?',
    complete_title: 'เสร็จสิ้นใบสั่งงาน',
    complete_description: 'ให้คะแนนคุณภาพงานที่เสร็จสิ้น (1-5 ดาว)',
    error_loading: 'เกิดข้อผิดพลาดในการโหลด',
    error_description: 'มีบางอย่างผิดปกติ',
    created_on: 'สร้างเมื่อ {{date}}',
  },

  // Filters
  filters: {
    all_properties: 'ทุกอาคาร',
    all_categories: 'ทุกหมวดหมู่',
    all_statuses: 'ทุกสถานะ',
    all_priorities: 'ทุกความสำคัญ',
    all_equipment: 'ทุกอุปกรณ์',
    all_vendors: 'ทุกผู้ให้บริการ',
    all_assignees: 'ทุกผู้รับมอบหมาย',
    active_only: 'ใช้งานเท่านั้น',
    search_equipment: 'ค้นหาอุปกรณ์...',
    search_work_orders: 'ค้นหาใบสั่งงาน...',
    search_vendors: 'ค้นหาผู้ให้บริการ...',
  },

  // Empty states
  empty: {
    equipment: 'ไม่พบอุปกรณ์',
    work_orders: 'ไม่พบใบสั่งงาน',
    vendors: 'ไม่พบผู้ให้บริการ',
    not_found: 'ไม่พบข้อมูล',
  },
}
